import { Component } from '@angular/core';
import { LoadingController, ModalController, NavParams, ToastController } from '@ionic/angular';
import { ProcessesService } from 'src/app/processes/processes.service';
import { BaseClass } from 'src/app/shared/classes/base';
import { QuestionTypeConfig } from 'src/app/shared/interfaces/process-config.interface';
import { TranslationService } from 'src/app/shared/services/translation.service';

@Component({
    selector: 'app-configuration-values-ruling',
    templateUrl: './configuration-values-ruling.page.html',
    styleUrls: ['./configuration-values-ruling.page.scss']
})
export class ConfigurationValuesRulingPage extends BaseClass {

    public config: QuestionTypeConfig;
    public language: 'pt-BR' | 'en-US' | 'es-ES';

    constructor(
        private _processesService: ProcessesService,
        private _loadingController: LoadingController,
        protected _toastController: ToastController,
        protected _translationService: TranslationService,
        public _modalController: ModalController,
        private _navParams: NavParams
    ) {
        super(_toastController, _translationService);
        this.config = this._navParams.get('typeConfig');
        this.language = this._navParams.get('language');

        if (!this.config.possibleValuesGlobalized
            || this.config.possibleValuesGlobalized['en-US'].length === 0
            || this.config.possibleValuesGlobalized['en-US'].length !== this.config.valuesAmount) {
            this.config.possibleValuesGlobalized = {
                'en-US': Array(this.config.valuesAmount).fill(''),
                'es-ES': Array(this.config.valuesAmount).fill(''),
                'pt-BR': Array(this.config.valuesAmount).fill('')
            };
            this.config.colors = Array(this.config.valuesAmount).fill('#001e62');
        }
        if (!this.config.description
            || this.config.description['en-US'].length === 0
            || this.config.description['en-US'].length !== this.config.valuesAmount) {
            this.config.description = {
                'en-US': Array(this.config.valuesAmount).fill(''),
                'es-ES': Array(this.config.valuesAmount).fill(''),
                'pt-BR': Array(this.config.valuesAmount).fill('')
            };
        }
        if (!this.config.confirmationTextEnabled
            || this.config.confirmationTextEnabled.length === 0) {
            this.config.confirmationTextEnabled = Array(this.config.valuesAmount).fill(false);
        }
        if (!this.config.confirmationText
            || this.config.confirmationText['en-US'].length === 0
            || this.config.confirmationText['en-US'].length !== this.config.valuesAmount) {
            this.config.confirmationText = {
                'en-US': Array(this.config.valuesAmount).fill(''),
                'es-ES': Array(this.config.valuesAmount).fill(''),
                'pt-BR': Array(this.config.valuesAmount).fill('')
            };
        }
        if (!this.config.valueLimitEnabled
            || this.config.valueLimitEnabled.length === 0
            || this.config.valueLimitEnabled.length !== this.config.valuesAmount) {
            this.config.valueLimitEnabled = Array(this.config.valuesAmount).fill(false);
        }
        if (!this.config.valueLimit
            || this.config.valueLimit.length === 0
            || this.config.valueLimit.length !== this.config.valuesAmount) {
            this.config.valueLimit = Array(this.config.valuesAmount).fill(0);
        }

        if (!this.config.colors || this.config.colors.length === 0) {
            this.config.colors = Array(this.config.valuesAmount).fill('#001e62');
        }
    }

    public valueTrackBy(index: number, obj) {
        return index;
    }

    public dismiss(): void {
        this._modalController.dismiss();
    }

    public changeSelectedLanguage(language: 'pt-BR' | 'en-US' | 'es-ES'): void {
        this.language = language;
    }

    public async save(): Promise<void> {
        if (!this.config.id) {
            const loading = await this._loadingController.create();
            await loading.present();
            this._processesService.addQuestionTypeConfig(this.config).subscribe(response => {
                this.config.id = response.data.id;
                loading.dismiss();
                this._modalController.dismiss();
            }, error => {
                loading.dismiss();
                this.notifyError(error);
            });
        } else {
            this._modalController.dismiss();
        }
    }

}
